import { CommonResponse } from 'models/common';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import { Restaurant, StoreSettingRequestPayload, UpdateStoreSettingRequestPayload } from './models';

const storeSettingService = {
  getAll(payload: StoreSettingRequestPayload): Promise<CommonResponse<Restaurant[]>> {
    const dataDate = moment(payload.data_date).format(DATE_HYPHEN_FORMAT);
    let url = `/restaurants?data_date=${dataDate}&display_type=0&is_consistency_type=${payload.is_consistency_type}&ng_number_type=${payload.ng_number_type}`;
    if (payload.name) {
      url += `&name=` + payload.name;
    } else if (payload.sale_type_id) {
      url += `&sale_type_id=` + payload.sale_type_id;
    }
    return axiosClient.get(url);
  },
  update(payload: UpdateStoreSettingRequestPayload[]): Promise<CommonResponse<any>> {
    const url = `/restaurants`;
    return axiosClient.patch(url, payload);
  },
  updateNgNumberConsistency(payload: number[]): Promise<CommonResponse<any>> {
    const url = `/restaurants/update-ng-number-consistency`;
    return axiosClient.patch(url, payload);
  },
  getItem(restaurantId: number): Promise<CommonResponse<Restaurant>> {
    let url = `/restaurant/${restaurantId}`;
    return axiosClient.get(url);
  },
};

export default storeSettingService;
